export const UPDATE_MAP_CONTRACT = `
  mutation UpdateMapContract($token: String!, $input: UpdateMAPContractInput!) {
    updateMapContract(token: $token, input: $input) {
      error {
        code
        message
        statusCode
      }
      data {
        mapId
        mpeId
        mapType
        contractName
        startDate
        endDate
        creditPct
        committedSpend
        tagValue
        taggedSpendMTD
        taggedSpendYTD
        totalCreditsReceived
        status
        updatedDate
        lastProcessedDate
      }
    }
  }
`
